/** Window for showing the pipeline "new" badge on recently applied candidates. */
export const NEW_APPLICANT_WINDOW_MS = 72 * 60 * 60 * 1000

export function isApplicantWithinNewWindow(
  appliedAtIso: string,
  nowMs = Date.now(),
): boolean {
  const appliedAt = new Date(appliedAtIso).getTime()
  if (Number.isNaN(appliedAt)) return false
  return nowMs - appliedAt < NEW_APPLICANT_WINDOW_MS
}
